const comments = [
  {
    name: '光影追梦人',
    time: '2小时前',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20with%20warm%20lighting%20and%20cinematic%20mood%2C%20soft%20focus%2C%20artistic%20profile%2C%20no%20identifiable%20real%20person%2C%20digital%20art%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '91麻豆免费视频网站真的是我用过最好的在线免费视频网站，资源丰富更新快，免费视频在线观看体验一流。推荐的91免费在线视频频道质量都很高！',
    likes: '326',
  },
  {
    name: '夜色微凉',
    time: '5小时前',
    avatar: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20profile%20with%20warm%20amber%20tones%2C%20cinematic%20portrait%20style%2C%20soft%20glowing%20highlights%2C%20digital%20art%2C%20no%20real%20person&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '免费高清视频在线播放真的很流畅，一点都不卡。91福利视频在线频道的精选内容每次都让我惊喜，已经是每天必刷的平台了！',
    likes: '251',
  },
  {
    name: '星空探索者',
    time: '1天前',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20face%20profile%20with%20warm%20golden%20light%2C%20cinematic%20moody%20atmosphere%2C%20digital%20art%2C%20no%20real%20identifiable%20person&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '91免费视频网站的APP做得非常棒，移动端看91在线观看视频网站很方便。收藏功能很实用，每天更新的91麻豆免费视频网站内容都值得一看。',
    likes: '189',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">用户评价</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">听听91麻豆免费视频网站用户怎么说</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 border border-background-200 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{c.text}</p>
              <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200">
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{c.likes}</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}